<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>AGB</lumiron-section-title>
  </lumiron-section-header>

  <lumiron-section-body>
    <div>
      <h3>1 Allgemeines</h3>
      <p>
        Alle Leistungen der Lumiron KLG unterliegen vollumfänglich diesen Bedingungen, sofern diese nicht ausdrücklich
        und schriftlich gegenseitig abgeändert, bzw. ergänzt worden sind.
      </p>
    </div>

    <div>
      <h3>2 Vertragsabschluss</h3>
      <p>
        Durch Senden einer Anfrage auf der Angebotsseite gibt der Kunde eine verbindliche Bestellung der ausgewählten
        Dienstleistung ab. Nach dem Erhalt der Bestellung, treten wir mit dem Kunden in Kontakt und bestätigen die
        Bestellung per E-Mail oder Telefon. Der Auftrag kommt erst zustande, wenn wir die Bestellung bestätigt haben.
      </p>
    </div>

    <div>
      <h3>3 Preise</h3>
      <p>
        Die Preise werden in Schweizer Franken (CHF) ausgewiesen. Es gelten die auf der Webseite angegebenen Preise zum
        Zeitpunkt des Bestelleinganges.
      </p>
    </div>

    <div>
      <h3>4 Zahlungsbedingungen</h3>
      <p>
        Die Leistung kann Bar oder per Banküberweisung bezahlt werden. Als Barzahlungsmittel gilt nur der Schweizer
        Franken (CHF). Bezahlt kann im Voraus, während der Leistung oder nachträglich werden. Bei einer nachträglichen
        Überweisung wird eine Zahlung innerhalb von 10 Tagen nach Leistung erwartet. Bei Verzug wird gemäss Art. 97 ff.
        OR vorgegangen.
      </p>
    </div>

    <div>
      <h3>5 Stornierung und Rückerstattung</h3>
      <p>
        Die Absage fester Reservationen muss bis spätestens {{ business.cancellationHours }} Stunden vor Leistungsbeginn
        erfolgen. Stornierungen zu einem späteren Zeitpunkt werden zum vollen Buchungspreise verrechnet. Bei
        rechtzeitiger Stornierung und bereits getätigter Zahlung wird der volle Betrag zurückerstattet.
      </p>
    </div>

    <div>
      <h3>6 Leistung</h3>
      <p>
        Die Leistung des Betreuten Bubble Soccers findet grundsätzlich nur bei schönem Wetter statt. Die Lumiron KLG
        behält sich jedoch das Recht vor, nach Vertragsabschluss und auch während der Aktivität das Programm oder
        einzelne Leistungen abzuändern, abzusagen oder abzubrechen, wenn Natur- und/oder Wetterverhältnisse oder
        sonstige unvorhergesehene Umstände (Covid 19, etc.) dies erfordern.<br />
        Die vereinbarte Dauer der Leistung beginnt mit dem vereinbarten Startzeitpunkt. Der Kunde ist verantwortlich
        pünktlich und vorbereitet (in Sportkleidung, etc.) zu erscheinen. Die Dauer der Leistung wird nicht verlängert.
      </p>
    </div>

    <div>
      <h3>7 Platz</h3>
      <p>
        Benutzt der Kunde einen eigenen Platz ist er verantwortlich einen geeigneten Platz (flach, Grass oder sonstiger
        weicher Untergrund, genügende Grösse, Zufahrtsmöglichkeit) bereitzustellen und die Rechte für die Benutzung
        dieses Platzes zu besitzen.<br />
        Die Lumiron KLG kann nicht für die Benutzung der Plätze von Partnern garantieren. Wird die Benutzung eines
        Platzes durch den Partner kurzfristig abgesagt, wird eine Alternative gesucht, bzw. der volle Betrag
        zurückerstattet. Die Lumiron KLG lehnt jegliche Haftung für den weiteren entstandenen Schaden ab.
      </p>
    </div>

    <div>
      <h3>8 Strafen</h3>
      <p>Die Lumiron KLG hält sich das Recht vor in folgenden Fällen eine Strafzahlung zu verlangen:</p>
      <ul>
        <li>
          wenn beim Unbetreuten Bubble Soccer die Bubbles dreckig retourniert werden: {{ business.damageDirtyChf }}.- Fr
        </li>
        <li>
          wenn beim Unbetreuten oder Betreuten Bubble Soccer durch fahrlässiges Verhalten Bubbles zerstört werden: {{
          business.damageDestroyedChf }}.- Fr pro zerstörtem Bubble
        </li>
      </ul>
    </div>

    <div>
      <h3>9 Versicherung und Haftung</h3>
      <p>
        Die Lumiron KLG lehnt jegliche Haftung für Unfälle, die sich vor, während oder nach der Leistung ereignen, ab.
        Unfall- und Haftpflichtversicherung ist Sache der Teilnehmer. Der Teilnehmer ist verpflichtet eine ausreichende
        Versicherung abgeschlossen zu haben. Für Kleidung und mitgebrachte Gegenstände, insbesondere Wertgegenstände und
        Geld, wird keine Haftung übernommen.<br />
        Gemäss Art. 394 ff. OR haftet die Lumiron KLG lediglich für die sorgfältige Ausführung des Auftrages. Werden bei
        der Ausführung der Leistung Hilfspersonen eingesetzt, lehnt die Lumiron KLG jegliche Haftung für den durch die
        Hilfspersonen entstandenen Schaden ab Art. 101 Abs 2 OR.
      </p>
    </div>

    <div>
      <h3>10 Datenschutz</h3>
      <p>
        Die Lumiron KLG behält sich das Recht vor allfälliges Bildmaterial für Marketingzwecke zu verwenden. Sie können
        die Erlaubnis für die Nutzung und Weitergabe der Daten und Bilder jederzeit widerrufen, indem Sie uns eine
        entsprechende Nachricht an
        <a [href]="'mailto:' + business.email">{{ business.email }}</a> senden. Die für die Geschäftsabwicklung
        notwendigen Daten werden vertraulich behandelt.
      </p>
    </div>

    <div>
      <h3>11 Gerichtsstand und anwendbares Recht</h3>
      <p>
        Gerichtsstand ist der Sitz der Lumiron KLG. Der Vertrag untersteht dem schweizerischen Recht. Sollte eine
        Bestimmung dieser allgemeinen Geschäftsbedingungen unwirksam sein, so bleibt der Vertrag im Übrigen wirksam.
        Anstelle der unwirksamen Bestimmung gelten die einschlägigen gesetzlichen Bestimmungen.
      </p>
    </div>
  </lumiron-section-body>
</lumiron-section>
